import React from "react";
import PropTypes from "prop-types";
import { Close, InfoIcon } from "~/theme/assets";
import classnames from "classnames";
import { saveToSessionStorage, getFromSessionStorage } from "../../utils/misc";
import { pure, withState, compose } from "recompose";
import constants from "../../utils/constants";
import { defineMessages, injectIntl } from "react-intl";
import styled from "styled-components";
import { wbBlue, wbGreen, wbOrange, wbRed, white } from "../../theme/variables";
import media from "../../utils/media";

export const msgs = defineMessages({
  occupancyNotPossible: {
    id: "room_selection.notification.occupancyNotPossible",
    description:
      "This message appears when there is no availability for the given occupants configuration",
    defaultMessage: "Impossible Configuration",
  },
  noResults: {
    id: "room_selection.notification.noResults",
    description: "No Results",
    defaultMessage: "No Results",
  },
});

const StyledNotification = styled.div`
  display: flex;
  align-items: center;
  color: ${white};
  background-color: ${props => props.backgroundColor};
  border-radius: ${props => (props.borderRadius ? "5px" : "0")};
  padding: 10px;
  word-break: break-word;
  font-size: 14px;
  text-align: left;
  ${media.up.md`
    display: ${props => (props.hidden ? "none" : "flex")};
  `};
`;

const StyledIcon = styled.span`
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
  margin-right: 10px;
  fill: ${white};
  display: block !important;
  align-self: baseline;
  & svg {
    margin-top: -5px;
  }
`;

const StyledIconClose = styled(StyledIcon)`
  cursor: pointer;
  margin-left: auto;
  margin-right: 0;
`;

const Text = styled.span`
  margin-right: 10px;
`;

/* TODO: REFACTOR THIS COMPONENT! */
function Notification({
  id,
  hide,
  position,
  type,
  text,
  propertyTicker,
  hideIcon,
  closeIcon,
  closedMessagesList,
  setVisible,
  intl: { formatMessage },
  className,
  borderRadius,
}) {
  let backgroundColor = "";

  switch (type) {
    case "success":
      backgroundColor = wbGreen;
      break;
    case "error":
      backgroundColor = wbRed;
      break;
    case "info":
      backgroundColor = wbBlue;
      break;
    case "warning":
    case "notice":
      backgroundColor = wbOrange;
      break;
    default:
      break;
  }
  const closedMessages = getFromSessionStorage("closedMessages") || {};
  const messageUniqueID = `${propertyTicker}_${position}_${id}`;
  const isOccupationMsg = id === constants.SPECIAL_MESSAGE_TYPES.OCCUPATION_MESSAGE;
  const noResults = id === constants.SPECIAL_MESSAGE_TYPES.NO_RESULTS;
  if (isOccupationMsg) {
    text = formatMessage(msgs.occupancyNotPossible); // eslint-disable-line
  }
  if (noResults) {
    text = formatMessage(msgs.noResults); // eslint-disable-line
  }
  if (
    closedMessages &&
    closedMessages[propertyTicker] &&
    closedMessages[propertyTicker][position] &&
    closedMessages[propertyTicker][position][id]
  ) {
    return null;
  }
  if (closedMessagesList.indexOf(messageUniqueID) !== -1) {
    return null;
  }
  function handleClose() {
    if (!closedMessages[propertyTicker]) {
      closedMessages[propertyTicker] = {};
    }
    if (!closedMessages[propertyTicker][position]) {
      closedMessages[propertyTicker][position] = {};
    }
    closedMessages[propertyTicker][position][id] = true;
    saveToSessionStorage("closedMessages", closedMessages);
    setVisible(val => [...val, messageUniqueID]);
  }

  return (
    <StyledNotification
      id={position && id ? position + "_" + id : ""}
      className={classnames("wbkv9-Notification", className)}
      backgroundColor={backgroundColor}
      hide={hide}
      borderRadius={borderRadius}>
      {(!hideIcon || isOccupationMsg || noResults) && (
        <StyledIcon>
          <InfoIcon />
        </StyledIcon>
      )}
      <Text className="wbkv9-Notification-content">{text}</Text>
      {closeIcon && !isOccupationMsg && !noResults && (
        <StyledIconClose onClick={handleClose} className="wbkv9-Notification-closeIcon">
          <Close />
        </StyledIconClose>
      )}
    </StyledNotification>
  );
}

Notification.propTypes = {
  type: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.oneOf(["success", "error", "warning", "notice", "info"]),
  ]),
  text: PropTypes.any,
  hideIcon: PropTypes.bool,
  closeIcon: PropTypes.bool,
};

Notification.defaultProps = {
  type: "success",
  text: "",
  hideIcon: false,
  closeIcon: false,
};

const enhance = compose(pure, withState("closedMessagesList", "setVisible", []), injectIntl);

export default enhance(Notification);
